import {find} from '../helpers';

const typewriter = find('[data-typewrite]');

if (typewriter) {
    import('./index');
}
